export default () => ({
  orgTypes: [],
  orgData: {},
  myOrgList: [],
  otherOrgList: [],
  serchMembers: [],
  numFollowersChannel: null,
  orgPosts: [],
  isLoading: false,
  joinRequests: [],
  noSearchMembers: null,
  noSearchOrgs: null,
  currentOrgProfile: null,
  bannedUsersList: [],
  followingChannels: [],
});
